"use client";

import { Facebook, Instagram, Youtube, Music, Mail, Phone, Globe, MapPin, House as Home, Radio, Shield, Send, Bike } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
const socialLinks = [{
  label: "Facebook",
  href: "https://facebook.com",
  Icon: Facebook,
  color: "bg-[#3b5998]"
}, {
  label: "Instagram",
  href: "https://instagram.com",
  Icon: Instagram,
  color: "bg-[#e4405f]"
}, {
  label: "YouTube",
  href: "https://youtube.com",
  Icon: Youtube,
  color: "bg-[#cd201f]"
}, {
  label: "TikTok",
  href: "https://tiktok.com",
  Icon: Music,
  color: "bg-[#000000]"
}];
const footerLinks = [{
  label: "Kebijakan Privasi",
  href: "/PrivacyPolicyPage"
}, {
  label: "Pedoman Media",
  href: "/CyberMediaGuidePage"
}];
const bottomMenuItems = [{
  label: "HOME",
  href: "/HomePage",
  Icon: Home
}, {
  label: "LIVE",
  href: "/LivePage",
  Icon: Radio
}, {
  label: "ZONA PP",
  href: "/PPZonePage",
  Icon: Shield
}, {
  label: "KIRIM",
  href: "/SendNewsPage",
  Icon: Send
}, {
  label: "POJOK OJOL",
  href: "/RideHailingCornerPage",
  Icon: Bike
}];
export default function Footer() {
  return <section data-section-id="1691" id="organizationfooter" className="relative bg-[#171717] bg-[radial-gradient(circle_at_top,_rgba(235,124,45,0.08)_0%,_transparent_70%)] text-white overflow-hidden">
      <div className="zona-pp-page pb-[76px]">
        <div className="zona-pp-header-wrapper sticky top-0 z-[999]">
          {}
        </div>

        <div className="zona-pp-bottom-menu fixed bottom-0 left-0 right-0 z-[998] bg-[#F97316]">
          <div className="w-full px-8 flex items-center justify-between min-h-[64px] sm:min-h-[80px]">
            {bottomMenuItems.map((item, i) => <Link key={item.label} to={item.href} data-index={i} className="flex flex-col items-center gap-1 text-white hover:text-white transition-colors group">
              <item.Icon className="size-5 sm:size-6 group-hover:scale-110 transition-transform" />
              <span className="text-[10px] sm:text-xs font-black tracking-widest uppercase">{item.label}</span>
            </Link>)}
        </div>
      </div>
    </div>

    <div className="zona-pp-footer-inner mx-auto max-w-[1220px] px-8 pt-20 pb-16 md:pt-24 md:pb-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[1.35fr_1.45fr_1.1fr_1fr] gap-[26px] lg:gap-[34px]">
          
          {}
          <div className="flex flex-row items-start gap-[18px] min-h-[96px] pr-[26px] border-b lg:border-b-0 lg:border-r border-white/12 pb-8 lg:pb-0">
            <Link to="/" className="shrink-0">
              <WvcLogo className="h-[72px] w-[72px]" />
            </Link>
            <div className="flex flex-col">
              <h4 className="text-[18px] font-black tracking-tight text-white uppercase leading-tight m-0 mb-1">
                ZONA PEMUDA PANCASILA
              </h4>
              <p className="m-0 text-[14px] font-black text-[#f36b10] uppercase tracking-wider">
                ABADI.NEWS
              </p>
              <p className="m-0 mt-3 text-[14px] leading-[1.55] text-white/78 italic">
                "Solidaritas • Loyalitas • Totalitas"
              </p>
            </div>
          </div>

          {}
          <div className="flex flex-col min-h-[96px] pr-[26px] border-b lg:border-b-0 lg:border-r border-white/12 pb-8 lg:pb-0">
            <h4 className="m-0 mb-3 text-[16px] font-black tracking-wider text-white uppercase">
              Alamat Sekretariat
            </h4>
            <div className="flex gap-3 text-white/78">
              <MapPin className="size-5 shrink-0 text-[#f36b10]" />
              <p className="m-0 mb-[6px] text-[14px] leading-[1.55]">
                Jl. Guntur Sari No.45, Haurpanggung, Kec. Tarogong Kidul, Kabupaten Garut, Jawa Barat 44151
              </p>
            </div>
          </div>

          {}
          <div className="flex flex-col min-h-[96px] pr-[26px] border-b lg:border-b-0 lg:border-r border-white/12 pb-8 lg:pb-0">
            <h4 className="m-0 mb-3 text-[16px] font-black tracking-wider text-white uppercase">
              Kontak
            </h4>
            <ul className="flex flex-col gap-2 list-none p-0 m-0">
              <li>
                <Link to="tel:+622621234567" className="flex items-center gap-3 text-[14px] text-white/78 hover:text-[#f36b10] transition-colors group">
                  <Phone className="size-4 text-[#f36b10]" />
                  <span className="leading-[1.55]">(0262) 1234567</span>
                </Link>
              </li>
              <li>
                <Link to="mailto:info@mppgarut.or.id" className="flex items-center gap-3 text-[14px] text-white/78 hover:text-[#f36b10] transition-colors group">
                  <Mail className="size-4 text-[#f36b10]" />
                  <span className="leading-[1.55]">info@mppgarut.or.id</span>
                </Link>
              </li>
              <li>
                <Link to="https://www.mppgarut.or.id" className="flex items-center gap-3 text-[14px] text-white/78 hover:text-[#f36b10] transition-colors group">
                  <Globe className="size-4 text-[#f36b10]" />
                  <span className="leading-[1.55]">www.mppgarut.or.id</span>
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div className="flex flex-col min-h-[96px] pb-8 lg:pb-0">
            <h4 className="m-0 mb-3 text-[16px] font-black tracking-wider text-white uppercase">
              Ikuti Kami
            </h4>
            <div className="flex flex-wrap gap-[14px]">
              {socialLinks.map(({
              label,
              href,
              Icon,
              color
            }, i) => <Link key={label} data-index={i} to={href} aria-label={label} className={`flex items-center justify-center size-[36px] rounded-lg ${color} text-white hover:scale-110 transition-all duration-300 shadow-md`}>
                  <Icon className="size-4" />
                </Link>)}
            </div>
          </div>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10">
          <p className="m-0 mx-auto text-center text-[14px] text-white/72 leading-relaxed max-w-2xl">
            © 2026 MPC Pemuda Pancasila Kabupaten Garut. All Rights Reserved.
          </p>
          <div className="flex items-center justify-center gap-6 mt-4">
            {footerLinks.map((link, i) => <Link key={link.label} data-index={i} to={link.href} className="text-[12px] text-white/60 hover:text-[#f36b10] uppercase font-bold tracking-widest transition-colors">
                {link.label}
              </Link>)}
          </div>
        </div>
    </section>;
}